module.exports = __webpack_public_path__ + "static/media/storm.dd196953.svg";